import getActiveLink from '../selectors/getActiveLink';
import unwrapLink from '../transforms/unwrapLink';
import wrapLink from '../transforms/wrapLink';
function toggleLink(editor, promptText) {
  var _activeLink$;
  const activeLink = getActiveLink(editor);
  const activeUrl = activeLink ? (_activeLink$ = activeLink[0]) === null || _activeLink$ === void 0 || (_activeLink$ = _activeLink$.data) === null || _activeLink$ === void 0 ? void 0 : _activeLink$.url : '';
  const url = window.prompt(promptText, activeUrl);
  if (url == null) return;
  if (url === '') {
    unwrapLink(editor);
    return;
  }
  wrapLink(editor, url);
}
export default toggleLink;